(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-acacak"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-opener-product]').forEach((section) => {
  const mainImage = section.querySelector('#OpenerMainImage');
  const thumbs = section.querySelectorAll('[data-gallery-image]');
  const price = section.querySelector('[data-product-price]');
  const packages = section.querySelectorAll('.package-input');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (mainImage) mainImage.src = thumb.dataset.galleryImage;
      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  packages.forEach((input) => {
    input.addEventListener('change', () => {
      if (input.checked && price) price.textContent = input.dataset.price;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
